import React, { useEffect, useState } from "react";
// import Image from "next/image";
import { fetchCountryCode } from "lib/utils/getCountryCode";
import Link from "next/link";

export const PremiumCard: React.FC = () => {
  const [countryCode, setCountryCode] = useState<string | null>(null);
  useEffect(() => {
    fetchCountryCode(setCountryCode);
  }, []);

  // Don't render the card until country code is loaded
  if (countryCode === null) {
    return null;
  }

  const price = countryCode === "IN" ? "₹69" : "$9";

  return (
    <div
      className={
        "relative my-2 box-border flex h-auto w-[215px] flex-col gap-1 2xl:gap-1 self-center rounded-[13.625px] px-2 py-1 shadow-lg 2xl:w-[230px] 2xl:px-4 2xl:py-2"
      }
      style={{
        background:
          "linear-gradient(134.45deg, #EAF1FF 13.44%, #FFFFFF 27.37%, #EAF1FF 36.99%, #FFFFFF 45.96%, #EAF1FF 56.2%, #FFFFFF 67.7%, #EAF1FF 78.47%, #FFFFFF 86.2%)",
        // border: "3.2625px solid #FFFFFF",
        // borderRadius: "13.05px",
      }}
    >
      {/* Header Text */}
      <div>
        {/* <h3 className="m-0 mb-1 text-[14px] leading-[18px] font-bold text-black">
          Upgrade your resume with
        </h3> */}
        <div className="flex items-baseline justify-center gap-2">
          <span className="text-[18px] font-bold leading-[22px] text-black 2xl:text-[22px] 2xl:leading-[25px]">
            Premium
          </span>
          <span className="text-[23px] font-bold leading-[25px] text-black 2xl:text-[32px] 2xl:leading-[38px]">
            {price}
          </span>
          <span className="text-[14px] font-normal leading-[18px] text-black">
            Only
          </span>
        </div>
        <p className="mt-0.5 text-center text-[10px] font-semibold leading-[12px] text-[#30325F] 2xl:text-[12px] 2xl:leading-[15px]">
          Or Upgrade for FREE with Referrals
        </p>
      </div>

      {/* Features List */}
      <div className="xl:flex hidden flex-col gap-1 rounded-xl bg-white/40 p-0.5 2xl:gap-1 2xl:p-1">
        <p className="m-0 rounded-lg bg-[#efe7f6] px-2 py-0.5 text-[9px] font-semibold leading-[11px] text-black 2xl:py-1 2xl:leading-[13px] 2xl:text-[10px]">
          Resume analysis and score check
        </p>

        <p className="m-0 rounded-lg bg-[#efe7f6] px-2 py-0.5 text-[9px] font-semibold leading-[11px] text-black 2xl:py-1 2xl:leading-[13px] 2xl:text-[10px]">
          Save unlimited resumes
        </p>
      </div>

      {/* Subscribe Button */}
      <Link href="/premium-subscription">
        <button
          className=" w-full rounded-lg border-[2px] border-solid border-white px-3 py-1 text-[13px] font-bold leading-[15px] text-[#ffffff] shadow-md transition-all hover:shadow-lg 2xl:py-1.5 2xl:text-[16px] 2xl:leading-[18px]"
          style={{
            background:
              "linear-gradient(90deg, #5866FB 0%, #7D86E3 49%, #5865FB 100%)",
            cursor: "pointer",
          }}
        >
          Subscribe Now
        </button>
      </Link>

      {/* Referral Section */}
      <Link href="/referral">
        <div className="flex flex-row gap-2 rounded-lg border border-[#EAF1FF] bg-white/30 p-1 2xl:mt-1 2xl:p-2 ">
          <div className="flex flex-shrink-0 items-center justify-center">
            {/* Megaphone SVG Icon */}
            <svg
              height="30px"
              width="24px"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 512 512"
              xmlSpace="preserve"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <circle
                  style={{ fill: "#EAF1FF" }}
                  cx="256"
                  cy="256"
                  r="256"
                ></circle>{" "}
                <path
                  style={{ fill: "#FFE356" }}
                  d="M208.809,445.312l-24.051-129.184l-64.137,23.322l46.463,119.527 C171.274,469.546,211.906,459.707,208.809,445.312z"
                ></path>{" "}
                <polygon
                  style={{ fill: "#FFE356" }}
                  points="186.215,324.327 184.757,315.946 120.438,339.268 124.447,349.29 "
                ></polygon>{" "}
                <path
                  style={{ fill: "#FFE356" }}
                  d="M227.576,283.695l196.054,12.208L329.794,58.124L195.143,201.338 c12.026,30.611,20.407,51.747,32.615,82.175L227.576,283.695z"
                ></path>{" "}
                <polygon
                  style={{ fill: "#FFE356" }}
                  points="227.576,283.695 423.63,295.903 415.248,274.585 223.932,274.585 "
                ></polygon>{" "}
                <g>
                  {" "}
                  <path
                    style={{ fill: "#6b68db" }}
                    d="M198.058,203.16c-2.186-5.466-7.47-8.746-11.661-6.924L73.976,241.059 c-4.373,1.64-6.013,7.653-3.826,13.119l16.399,41.543l16.399,41.361c2.186,5.466,7.47,8.746,11.661,6.924l112.421-44.823 c4.373-1.64,6.013-7.653,3.826-13.119l-16.399-41.361L198.058,203.16z"
                  ></path>{" "}
                  <path
                    style={{ fill: "#6b68db" }}
                    d="M434.198,290.073c2.004,5.102,0.182,10.75-4.373,12.572l0,0c-4.373,1.822-9.657-0.911-11.661-6.195 L325.238,61.404c-2.004-5.102-0.182-10.75,4.373-12.572l0,0c4.373-1.822,9.657,1.093,11.661,6.195L434.198,290.073z"
                  ></path>{" "}
                </g>{" "}
                <path
                  style={{ fill: "#FFE356" }}
                  d="M98.938,327.243l-25.873-65.23C26.42,274.403,46.827,348.743,98.938,327.243z"
                ></path>{" "}
                <path
                  style={{ fill: "#FFE356" }}
                  d="M435.838,148.68l-33.89,13.301c-2.004,0.729-2.733,3.644-1.64,6.377 c1.093,2.733,3.644,4.373,5.648,3.644l33.89-13.301c2.004-0.729,2.733-3.644,1.64-6.377 C440.393,149.591,437.842,147.952,435.838,148.68z"
                ></path>{" "}
                <path
                  style={{ fill: "#6b68db" }}
                  d="M166.172,456.974l42.636-10.932c6.195-1.64,9.11,10.021,2.915,11.661L169.27,468.27 c-5.831,1.458-8.928-9.657-3.28-11.115L166.172,456.974z"
                ></path>{" "}
                <g>
                  {" "}
                  <path
                    style={{ fill: "#FFE356" }}
                    d="M401.583,82.54l-21.865,29.153c-1.275,1.64-0.364,4.555,2.004,6.377 c2.369,1.822,5.284,1.822,6.559,0.182l21.865-29.153c1.275-1.64,0.364-4.555-2.004-6.377C405.774,80.9,402.858,80.9,401.583,82.54z "
                  ></path>{" "}
                  <path
                    style={{ fill: "#FFE356" }}
                    d="M458.978,229.762l-35.712-6.742c-2.004-0.364-3.28-3.098-2.733-6.013 c0.547-2.915,2.733-4.92,4.737-4.555l35.712,6.742c2.004,0.364,3.28,3.098,2.733,6.013 C463.169,228.122,460.982,230.127,458.978,229.762z"
                  ></path>{" "}
                </g>{" "}
                <path
                  style={{ fill: "#FFE356" }}
                  d="M90.374,245.25c-1.458,0.547-3.28-0.182-3.826-1.64c-0.547-1.458,0.182-3.28,1.64-3.826l76.891-29.7 c1.458-0.547,3.28,0.182,3.826,1.64c0.547,1.458-0.182,3.28-1.64,3.826L90.374,245.25z"
                ></path>{" "}
              </g>
            </svg>
          </div>
          <div className="flex-1">
            <p className="m-0 mb-0.5 text-[9px] font-bold  text-[#1E293B] 2xl:text-[12px]">
              Refer friends for upgrade for FREE!
            </p>
            <p className="m-0 text-[7px] font-medium text-[#475569]  2xl:text-[10px]">
              Invite friends and upgrade to premium for free when they
              visit resumemate.
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};
